import { render, staticRenderFns } from "./item-prices.vue?vue&type=template&id=1021a372"
import script from "./item-prices.vue?vue&type=script&lang=js"
export * from "./item-prices.vue?vue&type=script&lang=js"
import style0 from "./item-prices.vue?vue&type=style&index=0&id=1021a372&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports